<template>
  <div class="MyBuilder__body__body__holder d-flex flex-column">
    <div class="row floorPlanPurchaseHeader">
      <div class="modalPurchaseHeader">
        <div class="d-flex align-items-center">
          <i class="icon-left-arrow " @click="goback()" v-if="activeLeftNav !== 'blueprint'"
             style="padding-right: 10px"></i>
          <span class="title_project ">Välj projekttyp</span>
          <span class=" step_nr">{{ stepNr() }} / 3 steg</span>
        </div>
        <div>
          <div class="iconclose" @click="CloseModal">
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.375 2.625L2.625 9.375" stroke="#0A1D29" stroke-width="1.5" stroke-linecap="square"/>
              <path d="M9.375 9.375L2.625 2.625" stroke="#0A1D29" stroke-width="1.5" stroke-linecap="square"/>
            </svg>
          </div>
        </div>
      </div>
      <div class="col-md-12 modalPurchaseDescription" v-if="activeLeftNav !== 'blueprint'">
        <div>
          Vi har tänkt på dig som vill sköta bygganmälan med kommunen på egen hand! Vi erbjuder färdiga ritningspaket som våra arkitekter tagit fram och kvalitetsäkrat. Beställ ett utav våra färdiga ritningspaket som du enkelt kan bifoga i din bygganmälan till kommunen.
        </div>
      </div>
    </div>
    <div class="formSection"
         style="display: flex;border-top: 1px solid #EDEDED;"
         v-if="activeLeftNav === 'blueprint'"
         id="FloorPlansFormHolder" :class="activeLeftNav === 'blueprint' ? 'active' : ''">
      <floorplan_cards class=""/>
      <floorplan_viewer class=""/>
    </div>
    <div id="PaketsFormHolder" class="formSection"
         v-if="activeLeftNav === 'pakets'"
         :class="activeLeftNav === 'pakets' ? 'active' : ''">
      <floorplanpaket/>
    </div>
<!--    <div class="servicesForm w-100 h-100" v-if="activeLeftNav === 'services'">
      <services/>
    </div>-->
    <div class=" w-100 h-100" v-if="activeLeftNav === 'payment'">
      <div id="my-checkout-container" style="padding: 80px">
        <img src="@/assets/klarnaPlaceHolder.png" style="height: 100%;width: 320px;filter: blur(3px);" alt="">
      </div>
    </div>


  </div>
</template>

<script>
import floorplan_cards from "@/components/body/floorplan_cards";
import floorplanpaket from "@/components/body/plans";
import floorplan_viewer from "@/components/body/floorplan_viewer";
//import services from "@/components/body/services";

export default {
  name: "builder_body",
  data() {
    return {
      prevHeight: 0,
    }
  },
  components: {
    floorplan_viewer, floorplan_cards, floorplanpaket
  },
  computed: {
    activeLeftNav() {
      return this.$store.state.activeLeftNav
    },
  },
  methods: {
    CloseModal(){
      console.log('is CloseFloorPlanPurchaseModal')
      document.getElementById('HidePurchaseModal').click()
    },
    mutate_activeLeftNav(e) {
      this.$store.commit('mutate_activeLeftNav', e)
    },
    stepNr() {
      switch (this.activeLeftNav) {
        case 'pakets':
          return '2'
        case 'services':
          return '3'
        case 'payment':
          return '3'
        default:
          return '1'
      }
    },
    goback() {

      switch (this.activeLeftNav) {
        case 'pakets':
          this.mutate_activeLeftNav('blueprint')
          break;
        case 'payment':
          this.mutate_activeLeftNav('pakets')
          break;
        default:
          this.mutate_activeLeftNav('blueprint')
          break;
      }
    },
    ReturnClass(x) {
      document.getElementsByClassName('formSection').forEach(X => {
        X.classList.remove('active')
      })
      if (x === 'pakets') {
        document.getElementById('PaketsFormHolder').classList.add('active')
      }
      if (x === 'pakets') {
        document.getElementById('FloorPlansFormHolder').classList.add('active')
      }
    },
    generateClass() {
      switch (this.activeLeftNav) {
        case 'pakets':
          this.ReturnClass('pakets');
          break;
        case 'blueprint':
          this.ReturnClass('blueprint');
          break;
      }
    }
  }
}
</script>

<style lang="scss">
.floorPlanPurchaseHeader {
  overflow: hidden;
  padding: 0 15px;
}

.modalPurchaseDescription {
  padding: 0 30px;
  font-weight: 400;
  font-size: 14px;
  line-height: 167%;
  p{
    margin-bottom: 0;
  }
}

.modalPurchaseHeader {
  padding: 20px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .iconclose {
    background: #F3F3F3;
    border-radius: 38px;
    padding: 5px;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    &:hover {
      opacity: 0.8;
    }
  }
}

.title_project {
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  margin-right: 20px;
}

.step_nr {
  font-weight: 400;
  font-size: 14px;
  line-height: 167%;
  color: #6F6F6F;
}

.MyBuilder__body__body__holder {
  border: 1px solid #EDEDED;
  border-radius: 11px;
  display: flex;
  @media screen and (max-width: 769px) {
    flex-direction: column;
  }
}

</style>
